import {
  ApiFacility,
  ApiInternalStorageRecord,
  ApiInternalTransportRecord,
  InternalStorageRecord,
  InternalTransportRecord
} from "../../../../../types/prodcut-data-review/product-data.types";
import { STORAGE_ENV_MAP, STORAGE_MASS_UNIT_MAP } from "../constants/gateCardContent.constants";

export const toTransportRecord = (
  api: ApiInternalTransportRecord,
  transportTypeMap: Record<number, string>
): InternalTransportRecord => ({
  id: api._id,
  name: api.internalTransportName,
  averageDistance: api.averageDistance,
  transportType: (transportTypeMap[api.transportationType] ?? "") as InternalTransportRecord["transportType"],
  weight: api.weight,
  weightUnit: STORAGE_MASS_UNIT_MAP[api.weightUnit] ?? "kg",
  isEditing: false
});

export const toStorageRecord = (
  api: ApiInternalStorageRecord,
  facilityMap: Record<string, string>
): InternalStorageRecord => ({
  id: api._id,
  name: api.internalStorageName,
  dataType: (api.dataType || "Specific") as "Specific" | "Generic",
  environment: STORAGE_ENV_MAP[api.storageEnv] ?? "",
  warehouseName:
    typeof api.facilityId === "string"
      ? facilityMap[api.facilityId] ?? api.facilityId
      : (api.facilityId as ApiFacility)?.facilityName ?? "",
  storageTemperature: api.storageTemperature,
  warehouseSize: api.warehouseSize,
  weight: api.weight,
  weightUnit: STORAGE_MASS_UNIT_MAP[api.weightUnit] ?? "kg",
  electricity: api.electricity,
  utilization: api.utilizationOfWarehouse,
  storageDays: api.storageDays,
  isEditing: false
});
